import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorMessage } from 'app/core/error-handler/constants/error-message.constant';
import { Error } from 'app/core/error-handler/models';
import { ErrorHandlerService } from 'app/core/error-handler/services/error-handler.service';
import {
  createErrorHandled,
  createUnhandledError,
  ErrorActionType,
  ErrorRaised,
  UnhandledError,
} from 'app/core/error-handler/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class ErrorEffects {
  @Effect()
  public errorRaised$: Observable<Action> = this._actions$
    .pipe(
      ofType(ErrorActionType.ErrorRaised),
      tap(({ payload }: ErrorRaised) => this._errorHandlerService.error(payload.entity)),
      map(({ payload }: ErrorRaised) => createErrorHandled(payload.entity)),
      catchError((err: any) => of(createUnhandledError(new Error({
        message: ErrorMessage.unhandled,
        exception: err,
        source: 'ErrorEffects',
      })))));

  @Effect({ dispatch: false })
  public unhandledError$: Observable<Action> = this._actions$
    .pipe(
      ofType(ErrorActionType.UnhandledError),
      tap(({ payload }: UnhandledError) => {
        // TODO: react to critical errors here
      }));

  constructor(
    private readonly _actions$: Actions,
    private readonly _errorHandlerService: ErrorHandlerService) { }
}
